import { Outlet } from 'react-router';

import { cookieStore } from 'src/utils/cookieStore';
import { SidebarProvider } from '@/components/ui/sidebar';

type Props = {
  sidebar: React.ElementType;
};

const Layout = ({ sidebar: Sidebar }: Props) => {
  const defaultOpen = cookieStore.get('sidebar:state') ? cookieStore.get('sidebar:state')?.value === 'true' : true;

  return (
    <div className="flex h-dvh">
      <SidebarProvider
        style={
          {
            '--sidebar-width': '256px',
            '--sidebar-width-mobile': '48px',
          } as React.CSSProperties
        }
        defaultOpen={defaultOpen}
      >
        <Sidebar />

        <Outlet />
      </SidebarProvider>
    </div>
  );
};
export default Layout;
